var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"flex flex-col items-center token-swap"},[_c('h1',{staticClass:"text-center mb-0"},[_vm._v("Token Swap")]),_c('Swap',{key:_vm.key,staticClass:"max-w-[500px] animate__animated animate__fadeIn"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }